export const basePath = 'https://business-client-connection.herokuapp.com/api/v1';

export const clientIDimgr = 'c1f4aa1b9bc49fe';
